export const openCustomAttributePopup = (editor) => {
  const customAttributesPopupDiv = document.querySelector("#add-custom-attributes");
  if(customAttributesPopupDiv.classList.contains("d-none")) {
    customAttributesPopupDiv.classList = "";
    customAttributesPopupDiv.innerHTML = "";
  }

  const ATTRIBUTE_PREFIX = "data-custom-";

  const selectedComponent = editor.getSelected();
  const selectedComponentClassList = selectedComponent.getClasses();
  const selectedComponentClassesString = selectedComponentClassList.length > 0 ? `.${selectedComponentClassList.join(".")}` : "";
  const selectedComponentName = selectedComponent.getName();
  const componentFinalName = `${selectedComponentClassesString}<small title="Component Name" class="text-primary"> (${selectedComponentName})</small>`;

  const modal = `<div  class="fade modal show" role="dialog" aria-modal="true" style="display: block;">
    <div style="padding-right: 17px;" class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title h5">Add custom attribute</div>
          <button class="btn-close" aria-label="close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">Selected Component: ${componentFinalName}</div>
          <form>
            <div class="row mb-3">
              <div class="col">
                <div class="input-group">
                  <span class="input-group-text">${ATTRIBUTE_PREFIX}</span>
                  <input type="text" id="attribute-name" class="form-control rounded-end" placeholder="Enter attribute name">
                  <div class="invalid-feedback">Please ensure that some value is present and it  contains only the following characters: Lowercase characters, -, _</div>
                </div>
              </div>
              <div class="col">
                <input type="text" id="attribute-value" class="form-control rounded" placeholder="Enter attribute value">
              </div>
            </div>
            <div class="row">
              <div class="col">
                <input type="submit" disabled id="submit-btn" class="btn btn-primary w-100" value="Create Attribute">
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="fade modal-backdrop show"></div>`;

  customAttributesPopupDiv.innerHTML = modal;
  
  const closeBtn = document.querySelector("#add-custom-attributes .btn-close");
  const attributeNameInput = document.querySelector("#add-custom-attributes #attribute-name");
  const attributeValueInput = document.querySelector("#add-custom-attributes #attribute-value");
  const submitBtn = document.querySelector("#add-custom-attributes #submit-btn");

  closeBtn.addEventListener("click", () => {
    customAttributesPopupDiv.className = "d-none";
  });

  const validateAttributeName = (value) => {
    const pattern = /^[a-z0-9_-]+$/
    return pattern.test(value);
  }

  attributeNameInput.addEventListener("input", (e) => {
    e.preventDefault();
    const inputValue = e.currentTarget.value;
    const isInputValid = validateAttributeName(inputValue);

    if(isInputValid) {
      e.currentTarget.classList.remove("is-invalid");
      e.currentTarget.classList.add("is-valid");
      submitBtn.disabled = false;
    } else {
      e.currentTarget.classList.remove("is-valid");
      e.currentTarget.classList.add("is-invalid");
      submitBtn.disabled = true;
    }
  });
  
  submitBtn.addEventListener("click", (e) => {
    e.preventDefault();
    const attributeName = attributeNameInput.value;
    const attributeValue = attributeValueInput.value;

    selectedComponent.addTrait({
      type: "text",
      name: `${ATTRIBUTE_PREFIX}${attributeName}`,
      label: `Custom-${attributeName}`,
      placeholder: "Enter value",
      value: `${attributeValue}`,
      attributes: {
        title: `Custom-${attributeName}`
      }
    });

    selectedComponent.addAttributes({
      [`${ATTRIBUTE_PREFIX}${attributeName}`]: `${attributeValue}`
    });

    attributeNameInput.value = "";
    attributeValueInput.value = "";
    submitBtn.disabled = true;
    attributeNameInput.classList.remove("is-invalid", "is-valid");
  });
}